import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    deepStringFind,
    inject,
    ModalHandle,
    NothingHere,
    SubTopBar,
    Title,
    toArray,
} from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Input } from 'reactstrap';
import { AppStore } from '../Core/AppStore';
import { CreateOrEditWarehouseModal } from './CreateOrEditWarehouseModal';
import { WarehouseItem } from './WarehouseItem';
import { WarehouseStore } from './WarehouseStore';
import { BsColumns } from '@react-icons/all-files/bs/BsColumns';

export interface IWarehouseListProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class WarehouseList extends React.Component<IWarehouseListProps> {
    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            await this.warehouseStore.loadAllAsync();
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container">
                <Title>Warehouse</Title>

                <SubTopBar>
                    <Input
                        type="text"
                        value={this.searchValue}
                        onChange={this.onSearchInputChange}
                        placeholder="Search Warehouses..."
                    />

                    <div className="mx-2 border" />

                    <a className="btn btn-primary" onClick={this.openCreateWarehouseModal}>
                        Create Warehouse
                    </a>
                </SubTopBar>

                <div className="row">
                    <div className="col-12">
                        <CreateOrEditWarehouseModal modalHandle={this.createWarehouseModal} viewState="create" />
                        <NothingHere
                            empty={!this.warehouse.length}
                            icon={<BsColumns />}
                            loading={this.loading}
                            label="No Warehouses"
                            loadingMessage="Loading Warehouses..."
                        />
                    </div>

                    {this.warehouse.map(w => (
                        <div className="col-12 mb-3" key={w.warehouseGuid}>
                            <WarehouseItem warehouse={w} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    @bind
    private openCreateWarehouseModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.createWarehouseModal.open();
    }

    @bind
    @action
    private async onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    @computed
    private get warehouse() {
        let warehouse = toArray(this.warehouseStore.warehouses);

        if (this.searchValue) warehouse = warehouse.filter(o => deepStringFind(o, this.searchValue));

        return warehouse;
    }

    private createWarehouseModal = new ModalHandle();
    @observable
    private searchValue: string = '';
    @observable
    private loading = false;
    @inject
    private appStore!: AppStore;
    @inject
    private warehouseStore!: WarehouseStore;
}
